// extracted by css-extract-rspack-plugin
export default {"page":"TiUgT","seo_override":"EiY1Z","seoOverride":"EiY1Z","#":"sk62w"};